import { AnswerRequestMock } from "ApiGen/CustomerVerificationV2/model/models";

export class _AnswerRequestMock implements AnswerRequestMock { 
    constructor(public enable: boolean, public mockType: AnswerRequestMock.MockTypeEnum){};
}